<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                           <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                                        <label>Geographical Area Name</label>
                                        <input type="text" minlength="3" name="name" class="form-control" required v-model.lazy="region.name" placeholder="G.A Name" pattern ="[a-zA-Z-\sand mod]+">
                                        <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">G.A name is a required field</div>
                                            <div slot="pattern">G.A name is invalid</div>
                                            <div slot="minlength">Minimum length of G.A is 3 character</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                   <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select v-model="region.status" name="status" class="form-control">
                                            <option value = "" disabled>Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                            <div slot="pattern">Status is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionManager)">
                                        <label>GA Head</label>
                                        <select required v-model="region.regionManager" name="regionManager" class="form-control">
                                            <option disabled>Select G.A Head</option>
                                            <option v-for="(item,index) in managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">GA Head is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <!-- <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.journeyManager)">
                                        <label>Journey manager</label>
                                        <select required v-model="region.journeyManager" multiple name="journeyManager" class="form-control">
                                            <option disabled>Select Journey Manager</option>
                                            <option v-for="(item,index) in journey_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="journeyManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Journey Manager is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div> -->
                                <div class="col-sm-6">
                                    <label for="journeyManager" class="control-label"> Journey Manager </label>
                                    <!-- <div class="col-sm-5"> -->
                                        <vue-select label="journeyManager" multiple :options="this.journey_managers" :searchable="true" language="en-US" v-model="region.journeyManager" >
                                        </vue-select>
                                    <!-- </div> -->
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Region' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="createRegion" :disabled="!(formstate.$dirty && formstate.$valid)">Add G.A</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import { formService, eventBus , regionService} from '../../../services'
  import { EVENTS } from '../../../config'


  export default {
    name: 'RegionCreate',
    data () {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region : {
                status : 'active'
            },
            journey_managers : '',
            managers :''
        }
    },
    mounted : function() {
        this.getJourneyManager();
        this.getManager();
        
    },
    methods: {
        fieldClassName: formService.fieldClassName,
        createRegion () {
            this.loading = true;
            this.region.journeyManager = this.region.journeyManager.map(item => {
                return item.value
                }
            )
            return regionService.addRegion(this.region)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('G.A added!', 'Success!')
                this.$router.push('/ga')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Region Add failed!Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'New region add is failed.Please try again!'
                }
            })
        },
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        },
        getManager() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 2;
            let managerlist = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        managerlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.managers = managerlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Manager.requestFunction-error:', error)
                    this.$snotify.error('Get manager list failed', 'Error!')
                })
        },
        getJourneyManager() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 3;
            let journeyManagerlist = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    // if (res.data.docs) {
                    //     journeyManagerlist =  res.data.docs.map((item)=> {
                    //         return {
                    //             key : item._id, 
                    //             value : item.firstName +' '+item.lastName
                    //         }
                    //     })
                       
                    // }

                    // this.journey_managers = journeyManagerlist;


                    if (res.data.docs) {
                        journeyManagerlist =  res.data.docs;
                    }
                    this.journey_managers = journeyManagerlist.map(item => {
                        return { 
                            value : item._id,
                            journeyManager: `${item.firstName} ${item.lastName}`
                        }
                    }) 


                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Manager.requestFunction-error:', error)
                    this.$snotify.error('Get Journey Manager list failed', 'Error!')
                })
        },
        
    }
  }
</script>
<style scoped>
    .required-field > label::after  {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .gradientbt{
        background: #0F6940;
        color: white
    }
    
</style>



// WEBPACK FOOTER //
// RegionCreate.vue?702df32c